import { Box, Flex, Image, Text, useColorMode } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import {
    getRootPagePath
} from '../../App';
import Logos from '../../images/logos';
import { INetProfit } from '../../types';
import { formatCurrency } from '../../utils/format';
import Button from '../button';

interface HistoryTableProps {
    netProfits: INetProfit[];
    cid: string;
}

function HistoryTable(props: HistoryTableProps) {
    const { netProfits, cid } = props;
    const { push } = useHistory();
    const { colorMode } = useColorMode();

    const totalMissed = netProfits.reduce(
        (total, netProfit) => netProfit.metadata.netProfit + total,
        0
    );

    const showTotal = netProfits.length > 1;

    return (
            <Flex
                id="HistoryContainer"
                direction="column"
                w={netProfits.length > 0 ? { base: 'calc(100% + 32px)', md: 'full' } : { base: "", md: "50%"}}
                px={{ base: '16px', md: '0' }}
                overflowX={{ base: 'auto', md: 'hidden' }}
            >
                <Flex w="full" align="center">
                    {showTotal && (<Flex
                        align="center"
                        justify="center"
                        w="full"
                        h="56px"
                        bg={
                            colorMode == 'light'
                                ? 'skyGradientActive'
                                : 'alphaWhite005'
                        }
                        borderLeft="1px"
                        borderTop="1px"
                        borderColor={
                            colorMode == 'light' ? 'transparent' : 'alphaWhite005'
                        }
                        minW={{ base: '146px', md: 'unset' }}
                        maxW={{ base: "146px", md: "unset" }}
                    >
                        <Text size="md" lineHeight="19px" as="strong">
                            Total
                        </Text>
                    </Flex>)}
                    {netProfits.map((netProfit) => (
                        <Flex
                            key={netProfit.id}
                            align="center"
                            justify="center"
                            w="full"
                            h="56px"
                            bg={colorMode == 'light' ? 'white' : 'navy'}
                            borderTop="1px"
                            borderRight="1px"
                            borderLeft="1px"
                            borderColor={
                                colorMode == 'light' ? 'border' : 'alphaWhite005'
                            }
                            minW={{ base: '146px', md: 'unset' }}
                            maxW={{ base: "146px", md: "unset" }}
                        >
                            <Image
                                src={Logos[colorMode][netProfit?.book?.abbr]}
                                alt=""
                                h="25px"
                                maxW="60%" />
                        </Flex>
                    ))}
                    <Flex
                        align="center"
                        justify="center"
                        w="full"
                        h="56px"
                        bg={colorMode == 'light' ? 'white' : 'navy'}
                        borderTop="1px"
                        borderRight="1px"
                        borderLeft="1px"
                        borderColor={
                            colorMode == 'light' ? 'border' : 'alphaWhite005'
                        }
                        minW={{ base: '146px', md: 'unset' }}
                        maxW={{ base: "146px", md: "unset" }}
                    >
                        <Text size="md" lineHeight="19px" as="strong">
                            Add Account
                        </Text>
                    </Flex>
                    <Box
                        minW={{ base: '16px', md: '0' }}
                        h={{ base: '1px', md: '0' }}
                    ></Box>
                </Flex>
                <Flex w="full">
                    {showTotal && (<Flex
                        align="center"
                        justify="center"
                        w="full"
                        h="45px"
                        bg={
                            colorMode == 'light'
                                ? 'skyGradientActive'
                                : 'alphaWhite005'
                        }
                        borderLeft="1px"
                        borderBottom="1px"
                        borderColor={
                            colorMode == 'light' ? 'transparent' : 'alphaWhite005'
                        }
                        minW={{ base: '146px', md: 'unset' }}
                        maxW={{ base: "146px", md: "unset" }}
                    >
                        <Text
                            size="lg"
                            lineHeight="22px"
                            color={totalMissed < 0 ? 'red' : 'green'}
                            as="strong"
                        >
                            {formatCurrency(totalMissed)}
                        </Text>
                    </Flex>)}
                    {netProfits.map((netProfit) => (
                        <Flex
                            key={netProfit.id}
                            align="center"
                            justify="center"
                            w="full"
                            h="45px"
                            bg={colorMode == 'light' ? 'white' : 'navy'}
                            borderBottom="1px"
                            borderRight="1px"
                            borderLeft="1px"
                            borderColor={
                                colorMode == 'light' ? 'border' : 'alphaWhite005'
                            }
                            minW={{ base: '146px', md: 'unset' }}
                            maxW={{ base: "146px", md: "unset" }}
                        >
                            <Text
                                size="s"
                                fontWeight={showTotal ? "normal" : "bold"}
                                lineHeight="16px"
                                color={
                                    netProfit.metadata.netProfit < 0
                                        ? 'red'
                                        : 'green'
                                }
                            >
                                {formatCurrency(netProfit.metadata.netProfit)}
                            </Text>
                        </Flex>
                    ))}
                    <Flex
                        align="center"
                        justify="center"
                        w="full"
                        h="45px"
                        bg={colorMode == 'light' ? 'white' : 'navy'}
                        borderBottom="1px"
                        borderRight="1px"
                        borderLeft="1px"
                        borderColor={
                            colorMode == 'light' ? 'border' : 'alphaWhite005'
                        }
                        minW={{ base: '146px', md: 'unset' }}
                        maxW={{ base: "146px", md: "unset" }}
                    >
                        <Button
                            size="sm"
                            padding="10px"
                            variant="secondary"
                            onClick={() => {
                                push(getRootPagePath(cid));
                            }}
                        >
                            Choose Book
                        </Button>
                    </Flex>
                </Flex>
            </Flex>
    );
}

export default HistoryTable;
